<template>
  <div class="basic_text_material">
    <el-scrollbar style="height: calc(100vh - 70px)">
      <div class="text-preview-list">
        <div class="content" v-if="$route.query.channelType != 4">
            <div class="title">
                <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-haibaoxinxi16"></use>
                </svg>海报信息
            </div>
            <div class="text-item text-h1" @click="add_module(textStyle, 'companyName')" @dragend="dragend('textStyle', 'companyName')" draggable="true">企业简称</div>
            <div class="text-item text-h2" @click="add_module(textStyle, 'gatewayName')" @dragend="dragend('textStyle', 'gatewayName')" draggable="true">门户名称
                <el-tooltip
                class="item"
                content="仅在招聘门户中生效"
                placement="top"
                >
                    <i class="icon iconfont icon-info14"></i>
                </el-tooltip>
            </div>
            <div class="text-item text-content" @click="add_module(textStyle, 'userName')" @dragend="dragend('textStyle', 'userName')" draggable="true">用户姓名</div>
        </div>
        <div class="content" v-if="['imageText','operatingActivities'].includes($route.query.type)">
            <div class="title">
                <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-zhiweixinxi16"></use>
                </svg>
                {{$route.query.channelType == '4'? '活动':'职位'}}信息
            </div>
            <div class="text-item text-h1" @click="add_module(h1Style, $route.query.channelType == '4'?'activityName':'positionName')">{{$route.query.channelType == '4'? '活动':'职位'}}名称
                <el-tooltip
                class="item"
                content="点击预览按钮切换查看单个职位/多个职位"
                placement="top"
                >
                    <i class="icon iconfont icon-info14" v-show="$route.query.channelType != '4'" ></i>
                </el-tooltip>
            </div>
            <div class="text-item text-h2" @click="add_module(textStyle, $route.query.channelType == '4'?'activityInfo':'positionInfo')">{{$route.query.channelType == '4'? '活动介绍':'职位信息'}}
                <el-tooltip
                class="item"
                content="单个职位时将展示职位概览信息，多个职位时不展示"
                placement="top"
                >
                    <i class="icon iconfont icon-info14" v-show="$route.query.channelType != '4'"></i>
                </el-tooltip>
            </div>
        </div>
        <div class="content custom">
            <div class="title">
                <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-zidingyiwenben16"></use>
                </svg>
                自定义文本
            </div>
            <div class="text-item text-h1"    @dragend="dragend('textStyle')" draggable="true">拖拽添加文本</div>
            <div class="text-item text-content"   @dragend="dragend('contentStyle')" draggable="true">拖拽添加文本域</div>
        </div>
      </div>
    </el-scrollbar>
  </div>
</template>

<script type="text/javascript">
export default {
  name: 'BasicTextMaterial',
  data() {
    return {
      h1Style: {
        _style: {
          font_family: 'font-25',
          'font-size': 30,
          'line-height': 36,
          'font-weight': 'bold',
          width: 200
        }
      },
      textStyle: {
        _style: {
          font_family: 'font-25',
          'font-size': 14,
          'line-height': 18,
          width: 200
        },
        style:{
            
        }
      },
      contentStyle: {
        _style: {
          font_family: 'font-25',
          'font-size': 14,
          'line-height': 18,
          height: 80,
          width: 200
        },
        style:{
            
        }
      },
      artConfig: {
        shadow: [
          {
            is_art: true,
            properties: {
              wordArtType: 0,
              shadow: {
                h: 0,
                v: 0,
                blur: 0.3,
                color: 'rgb(107, 125, 153)'
              },
              initType: 1
            },
            _style: {
              color: '#ffffff'
            }
          },
          {
            is_art: true,
            properties: {
              wordArtType: 0,
              shadow: {
                h: 0,
                v: 0,
                blur: 0.3,
                color: 'rgb(161, 88, 179)'
              },
              initType: 1
            },
            _style: {
              color: '#ffffff'
            }
          },
          {
            is_art: true,
            properties: {
              wordArtType: 0,
              shadow: {
                h: 4,
                v: 0,
                blur: 0.4,
                color: 'rgb(0, 0, 0)'
              },
              initType: 1
            },
            _style: {
              color: '#ffffff'
            }
          },
          {
            is_art: true,
            properties: {
              wordArtType: 0,
              shadow: {
                h: 0,
                v: 6,
                blur: 0.3,
                color: 'rgb(224, 84, 4)'
              },
              initType: 1
            },
            _style: {
              color: '#ffffff'
            }
          },
          {
            is_art: true,
            properties: {
              wordArtType: 0,
              shadow: {
                h: 0,
                v: 0,
                blur: 0.3,
                color: 'rgb(196, 67, 60)'
              },
              initType: 1
            },
            _style: {
              color: '#ffffff'
            }
          },
          {
            is_art: true,
            properties: {
              wordArtType: 0,
              shadow: {
                h: 0,
                v: 0,
                blur: 0.5,
                color: 'rgb(25, 69, 136)'
              },
              initType: 1
            },
            _style: {
              color: '#ffffff'
            }
          }
        ],
        threeD: [
          {
            is_art: true,
            properties: {
              wordArtType: 1,
              angle: 135,
              shadow: {
                h: 3,
                v: 4,
                blur: 0.2,
                color: 'rgb(159,174,199)'
              },
              threeDs: [
                {
                  size: 3,
                  color: 'rgb(215,138,53)'
                }
              ],
              initType: 1
            },
            _style: {
              color: 'rgb(247, 227, 185)'
            }
          },
          {
            is_art: true,
            properties: {
              wordArtType: 1,
              angle: 164,
              shadow: {
                h: 3,
                v: 4,
                blur: 0.2,
                color: 'rgb(159,190,236)'
              },
              threeDs: [
                {
                  size: 3,
                  color: 'rgb(61,104,168)'
                }
              ],
              initType: 1
            },
            _style: {
              color: 'rgb(131, 170, 226)'
            }
          },
          {
            is_art: true,
            properties: {
              wordArtType: 1,
              angle: 172,
              shadow: {
                h: 3,
                v: 4,
                blur: 0.2,
                color: 'rgba(255,255,255,1)'
              },
              threeDs: [
                {
                  size: 4,
                  color: 'rgb(231,116,148)'
                }
              ],
              initType: 1
            },
            _style: {
              color: 'rgb(236, 182, 61)'
            }
          },
          {
            is_art: true,
            properties: {
              wordArtType: 1,
              angle: 155,
              shadow: {
                h: 3,
                v: 4,
                blur: 0.2,
                color: 'rgb(255,255,255)'
              },
              threeDs: [
                {
                  size: 3,
                  color: 'rgb(0, 0, 0)'
                }
              ],
              initType: 1
            },
            _style: {
              color: 'rgb(113, 113, 239)'
            }
          },
          {
            is_art: true,
            properties: {
              wordArtType: 1,
              angle: 135,
              shadow: {
                h: 3,
                v: 4,
                blur: 0.2,
                color: 'rgba(159,174,199)'
              },
              threeDs: [
                {
                  size: 3,
                  color: 'rgb(255,121,162)'
                }
              ],
              initType: 1
            },
            _style: {
              color: 'rgb(111, 151, 218)'
            }
          },
          {
            is_art: true,
            properties: {
              wordArtType: 1,
              angle: 187,
              shadow: {
                h: 6,
                v: 4,
                blur: 0.2,
                color: 'rgb(159,174,199)'
              },
              threeDs: [
                {
                  size: 3,
                  color: 'rgb(251,133,53)'
                }
              ],
              initType: 1
            },
            _style: {
              color: 'rgb(253, 194, 69)'
            }
          }
        ],
        stroke: [
          {
            is_art: true,
            properties: {
              wordArtType: 2,
              angle: 135,
              shadow: {
                h: 5,
                v: 5,
                blur: 0.2,
                color: 'rgb(125,144,175)'
              },
              threeDs: [
                {
                  size: 3,
                  color: 'rgb(214,214,214)'
                }
              ],
              stroke: {
                size: 1,
                color: 'rgb(255,255,255)'
              },
              initType: 1
            },
            _style: {
              color: 'rgb(253, 94, 0)'
            }
          },
          {
            is_art: true,
            properties: {
              wordArtType: 2,
              angle: 115,
              shadow: {
                h: 5,
                v: 5,
                blur: 0.2,
                color: 'rgb(125,144,175)'
              },
              threeDs: [
                {
                  size: 5,
                  color: 'rgb(214,214,214)'
                }
              ],
              stroke: {
                size: 1,
                color: 'rgb(255,255,255)'
              },
              initType: 1
            },
            _style: {
              color: 'rgb(89, 199, 249)'
            }
          },
          {
            is_art: true,
            properties: {
              wordArtType: 2,
              angle: 135,
              shadow: {
                h: 5,
                v: 5,
                blur: 0.2,
                color: 'rgb(125,144,175)'
              },
              threeDs: [
                {
                  size: 3,
                  color: 'rgb(255,255,255)'
                }
              ],
              stroke: {
                size: 1,
                color: 'rgb(255,255,255)'
              },
              initType: 1
            },
            _style: {
              color: 'rgb(77, 143, 243)'
            }
          },
          {
            is_art: true,
            properties: {
              wordArtType: 2,
              angle: 135,
              shadow: {
                h: 5,
                v: 5,
                blur: 0.2,
                color: 'rgb(125,144,175)'
              },
              threeDs: [
                {
                  size: 3,
                  color: 'rgb(214,214,214)'
                }
              ],
              stroke: {
                size: 1,
                color: 'rgb(191,76,118)'
              },
              initType: 1
            },
            _style: {
              color: 'rgb(255, 255, 255)'
            }
          },
          {
            is_art: true,
            properties: {
              wordArtType: 2,
              angle: 135,
              shadow: {
                h: 5,
                v: 5,
                blur: 0.2,
                color: 'rgb(125,144,175)'
              },
              threeDs: [
                {
                  size: 4,
                  color: 'rgb(214,214,214)'
                }
              ],
              stroke: {
                size: 1,
                color: 'rgb(255,255,255)'
              },
              initType: 1
            },
            _style: {
              color: 'rgb(255, 121, 162)'
            }
          },
          {
            is_art: true,
            properties: {
              wordArtType: 2,
              angle: 135,
              shadow: {
                h: 7,
                v: 4,
                blur: 0.2,
                color: 'rgb(125, 144, 175)'
              },
              threeDs: [
                {
                  size: 3,
                  color: 'rgb(214, 214, 214)'
                }
              ],
              stroke: {
                size: 1,
                color: 'rgb(255, 255, 255)'
              },
              initType: 1
            },
            _style: {
              color: 'rgb(113, 113, 239)'
            }
          }
        ],
        multi: [
          {
            is_art: true,
            properties: {
              wordArtType: 3,
              angle: 160,
              shadow: {
                h: 10,
                v: 10,
                blur: 0.2,
                color: 'rgb(125, 144, 175)'
              },
              threeDs: [
                {
                  size: 2,
                  color: 'rgb(37,64,128)'
                },
                {
                  size: 2,
                  color: 'rgb(52,219,119)'
                },
                {
                  size: 2,
                  color: 'rgb(42,71,172)'
                },
                {
                  size: 2,
                  color: 'rgb(51, 57, 73)'
                }
              ],
              initType: 1
            },
            _style: {
              color: 'rgb(255, 255, 255)'
            }
          },
          {
            is_art: true,
            properties: {
              wordArtType: 3,
              angle: 160,
              shadow: {
                h: 10,
                v: 10,
                blur: 0.2,
                color: 'rgb(125, 144, 175)'
              },
              threeDs: [
                {
                  size: 2,
                  color: 'rgb(255, 255, 255)'
                },
                {
                  size: 2,
                  color: 'rgb(219, 52, 219)'
                },
                {
                  size: 2,
                  color: 'rgb(255, 190, 208)'
                },
                {
                  size: 2,
                  color: 'rgb(73, 65, 51)'
                }
              ],
              initType: 1
            },
            _style: {
              color: 'rgb(40, 207, 213)'
            }
          },
          {
            is_art: true,
            properties: {
              wordArtType: 3,
              angle: 157,
              shadow: {
                h: 10,
                v: 10,
                blur: 0.2,
                color: 'rgb(125, 144, 175)'
              },
              threeDs: [
                {
                  size: 2,
                  color: 'rgb(124, 112, 112)'
                },
                {
                  size: 2,
                  color: 'rgb(255, 255, 255)'
                },
                {
                  size: 2,
                  color: 'rgb(180, 167, 167)'
                },
                {
                  size: 2,
                  color: 'rgb(119, 111, 111)'
                }
              ],
              initType: 1
            },
            _style: {
              color: 'rgb(228, 216, 216)'
            }
          }
        ]
      },
    }
  },
  props: {
    module: {
      type: Object,
      default: null
    }
  },
  methods: {
    dragend(data, type) {
      var canvasInfo = document.querySelector('.center_frame_relative').getBoundingClientRect()
      var y = window.event.layerY - canvasInfo.top
      var x = window.event.layerX - canvasInfo.left
      console.log(x,y,'ddddddddd')
      this[data]._style.top= y + 40
      this[data]._style.left= x - 30
      this[data].style.top= y + 40 // 兼容找不到数据处理
      this[data].style.left= x - 30  // 兼容找不到数据处理
      this.add_module(this[data], type)
    },
    add_module(option = {}, type) {
      // 职位详情海报的企业简称、门户名称、用户名称因为分区域不做处理拦截
    //   if(this.$route.query.type == 'detail' && ['companyName', 'gatewayName', 'userName'].includes(type)) return 
      option.textType = type
      this.templet.add_module('text', option)
    },
    on_click_add_art_text(art) {
      this.templet.add_module('text', art)
    }
  },
  computed: {},
  created() {},
  mounted() {
  },
  components: {}
}
</script>

<style lang="scss" scoped>
.row-btn {
  text-align: center;
  margin-top: 23px;
}

.btn-add-text {
  width: 240px;
  height: 36px;
  background: #0086ff;
  border-radius: 4px;
  color: #fff;
  padding: 0;

  &:hover,
  &:active,
  &:focus {
    background: #0086ff;
  }

  span {
    display: inline-block;
    vertical-align: middle;
  }

  .icon-add {
    display: inline-block;
    width: 14px;
    height: 13px;
    background-image: url('/images/icon/icon-ani-add@2x.png');
    background-size: 100% 100%;
    vertical-align: middle;
    margin-right: 5px;
  }
}

.text-preview-list {
  padding:16px 12px;
  .content{
    .title{
        font-size: 14px;
        color: #1D2129;
        font-weight: 500;
        line-height: 40px;
        .icon{
            width: 16px;
            height: 16px;
            margin-right: 10px;
            vertical-align: -3px;
            color: #4E5969;
        }
    }
    .text-item {
        cursor: pointer;
        line-height: 40px;
        height: 40px;
        border:#E5E6EB solid 1px;
        border-radius: 4px;
        margin-bottom: 12px;
        padding-left: 63px;
        font-size: 14px;
        .icon{
            margin-left: 4px;
            vertical-align: 1px;
            font-size: 14px;
            color: #4E5969;
        }
    }
    &.custom{
        .text-item{
            padding-left: 0;
            text-align: center;
            &:last-child{
                // line-height:56px;
            }
        }
    }
  }
}
::v-deep .el-scrollbar__wrap {
  overflow-x: hidden;
}
</style>
